import "./ClosedRequest.css";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { db } from "../../index";
import { ref, get, update, remove, onValue } from "firebase/database";
import { useUserRole } from "../../components/Context/useUserRole";

export function UpdateClosedRequest() {
const { closeRequestID } = useParams();
const [request, setRequest] = useState({});
const [loading, setLoading] = useState(true);
const navigate = useNavigate();
const [formValues, setFormValues] = useState({
    nameObject: "",
    address: "",
    engineer: "",
    contactPersonName: "",
    contactPersonPhone: "",
    description: "",
    date: "",
    createdDate: "",
});
const role = useUserRole();

const [engineers, setEngineers] = useState([]);

    const fetchEngineers = () => {
      const usersRef = ref(db, "users");
      onValue(usersRef, (snapshot) => {
        const usersData = snapshot.val();
        const engineersList = Object.values(usersData).filter((user) => user.role === "Инженер");
        setEngineers(engineersList);
      });
    };
  
    useEffect(() => {
      fetchEngineers();
    }, []);


useEffect(() => {
    const requestRef = ref(db, `request/${closeRequestID}`);
    get(requestRef).then((snapshot) => {
        if (snapshot.exists()) {
            const requestValues = snapshot.val();
            setRequest(requestValues);
            setFormValues({
                ...requestValues,
            });
            setLoading(false);
        } else {
            console.error(`Заявка с ID ${closeRequestID} не найдена`);
        }
    });
}, [closeRequestID]);

const handleFormChange = ({ target: { name, value } }) => {
    setFormValues((prevFormValues) => ({...prevFormValues, [name]: value }));
};

const deleteRequest = async () => {
    const requestRef = ref(db, `request/${closeRequestID}`);
    await remove(requestRef);
    console.log(`Request with ID ${closeRequestID} deleted successfully`);
    navigate("/closedRequest");
};

const openedRequest = async () => {
    const requestRef = ref(db, `request/${closeRequestID}`);
    await update(requestRef, { idRequest: false });
    console.log(`Request with ID ${closeRequestID} closed successfully`);
    navigate("/closedRequest");
};

if (loading) {
    return <div>Loading...</div>;
}

    return (
        <div className="center">
            <div class="aside-right__desc">
                <form className="modal" onSubmit={(event) => event.preventDefault()}>
                    <h2>Управление заявкой</h2>
                    <div className="modal__item">
                        <label>
                            Объект
                            <input
                                className="readOnly"
                                type="text"
                                name="nameObject"
                                value={formValues.nameObject}
                                onChange={handleFormChange}
                                placeholder="Название объекта"
                                readOnly
                            />
                        </label>
                    </div>
                    <div className="modal__item">
                        <label>
                            Адрес
                            <input
                                className="readOnly"
                                type="text"
                                name="address"
                                value={formValues.address}
                                onChange={handleFormChange}
                                placeholder="Адрес"
                                readOnly
                            />
                        </label>
                    </div>
                    <div class="modal__item">
                        <label>
                            Создана:
                            <input 
                                className="inputDate readOnly"
                                type="date"
                                name="createdDate"
                                value={formValues.createdDate}
                                onChange={handleFormChange}
                                placeholder="Введите email"
                                readOnly
                            />
                        </label>
                    </div>
                    <div className="modal__item">
                        <label>
                            Контактное лицо на объекте
                            <div className="contactPerson">
                                <input
                                    className="readOnly"
                                    type="text"
                                    name="contactPersonName"
                                    value={formValues.contactPersonName}
                                    onChange={handleFormChange}
                                    placeholder="Имя"
                                    readOnly
                                />
                                <input
                                    className="readOnly"
                                    type="tel"
                                    name="contactPersonPhone"
                                    value={formValues.contactPersonPhone}
                                    onChange={handleFormChange}
                                    placeholder="Телефон"
                                    readOnly
                                />
                            </div>
                        </label>
                    </div>
                    <div className="modal__item">
                        <label>
                            Дата ремонта
                            <input
                                className="inputDate readOnly"
                                type="date"
                                name="date"
                                value={formValues.date}
                                onChange={handleFormChange}
                                placeholder="Дата ремонта"
                                readOnly
                            />
                        </label>
                    </div>
                    <div className="modal__item">
                        <label htmlFor="engineer">Инженер
                            <input
                                className="readOnly"
                                type="text"
                                name="engineer"
                                value={formValues.engineer}
                                onChange={handleFormChange}
                                placeholder="Инженер"
                                readOnly
                            />
                        </label>
                    </div>
                    <div className="modal__item modal__textarea">
                        <label>
                            Описание проблемы
                            <textarea
                                className="readOnly"
                                type="text"
                                name="description"
                                value={formValues.description}
                                onChange={handleFormChange}
                                placeholder="Опишите проблему"
                                formcontrolname="description"
                                maxlength="400"
                                readOnly
                            />
                        </label>
                    </div>
                    <div className="modal__actions  modal__actions_btns">
                        {role === "Инженер" && (
                        <>
                        </>
                        )}
                        {role === "Директор" && (
                        <>
                            <button className="modal__button btn-item" onClick={openedRequest}>
                                Открыть
                            </button>
                            <button className="modal__button btn-item_delete" onClick={deleteRequest}>
                                Удалить
                            </button>
                        </>
                        )}
                        {role === "Диспетчер" && (
                        <>
                            <button className="modal__button btn-item" onClick={openedRequest}>
                                Открыть
                            </button>
                            <button className="modal__button btn-item_delete" onClick={deleteRequest}>
                                Удалить
                            </button>
                        </>
                        )}
                    </div>
                </form>
            </div> 
        </div>
    );
}
